import React from "react";
import _ from "lodash";
import { Form, Select } from "antd";

const Option = Select.Option;
const FormItem = Form.Item;

const renderOption = item => (
  <Option key={item.value} value={item.value}>
    {item.label}
  </Option>
);

const SelectField = ({
  value,
  name,
  label,
  onChange,
  type,
  disabled = false,
  placeholder = "Selecciona",
  options = [],
  onBlur,
  required,
  errors
}) => {
  return (
    <FormItem
      // {...formItemLayout}
      label={label}
      validateStatus={errors[name] ? "error" : null}
      help={errors[name] || null}
      required={required}
    >
      <Select
        mode="multiple"
        size="large"
        // style={{ width: "100%" }}
        placeholder={placeholder}
        value={value}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled || !options.length}
      >
        {_.map(_.orderBy(options, ["order", "value"], ["asc", "asc"]), option =>
          renderOption(option)
        )}
      </Select>
    </FormItem>
  );
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/Modules/FormFields/MultiSelectField.js